var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card',{attrs:{"outlined":"","color":"transparent"}},[_c('v-card-text',[_c('div',{staticClass:"tiptap-content",style:({'color': _vm.bodyTextColor}),domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }